import { useState, useEffect } from 'react';
import { apiClient } from '../lib/api-client';
import type { PartyCountResponse } from '../lib/types';

interface UsePartyCountReturn {
  partyCount: number;
  peekCount: number;  // 修正指示その３: のぞき人数を追加
  viewers: Array<{ username: string; joined_at: string }>;
  peekViewers: Array<{ username: string; joined_at: string }>;  // 修正指示その３
  isLoading: boolean;
  error: Error | null;
}

/**
 * Party chat participant and peek viewer count polling hook (修正指示その３)
 * Polls GET /api/streams/{streamKey}/party-count every 5 seconds
 * Now returns both party and peek counts separately
 */
export function usePartyCount(streamKey: string | null): UsePartyCountReturn {
  const [partyCount, setPartyCount] = useState<number>(0);
  const [peekCount, setPeekCount] = useState<number>(0);
  const [viewers, setViewers] = useState<Array<{ username: string; joined_at: string }>>([]);
  const [peekViewers, setPeekViewers] = useState<Array<{ username: string; joined_at: string }>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!streamKey) {
      setIsLoading(false);
      return;
    }

    let isMounted = true;
    let intervalId: number | null = null;

    const fetchPartyCount = async () => {
      try {
        const response: PartyCountResponse = await apiClient.getPartyCount(streamKey);

        if (isMounted) {
          setPartyCount(response.party_count);
          setPeekCount(response.peek_count);
          setViewers([]);
          setPeekViewers([]);
          setError(null);
          setIsLoading(false);
        }
      } catch (err) {
        if (isMounted) {
          setError(err instanceof Error ? err : new Error('Failed to fetch party count'));
          setIsLoading(false);
        }
      }
    };

    // Initial fetch
    fetchPartyCount();

    // Poll every 5 seconds
    intervalId = window.setInterval(fetchPartyCount, 5000);

    return () => {
      isMounted = false;
      if (intervalId !== null) {
        clearInterval(intervalId);
      }
    };
  }, [streamKey]);

  return {
    partyCount,
    peekCount,
    viewers,
    peekViewers,
    isLoading,
    error,
  };
}
